<nav 
  class="new-custom-route__nav" 
  [class.is-loading-resources]="checkIfLoadingNewResources()"
>
  <ul class="nav__items">
    @for ( item of navItems; track item.value ) {
      @if (!checkIsDisabled(item)) {
        <li 
          class="nav__item"
          (click)="handleNavItemClick(item)"
        >
          <app-nav-button 
            [label]="item.label | translate"
            [iconName]="item.iconName"
            [active]="mobileViewsState() === item.value"
          />
        </li>
      }
    }
  </ul>
</nav>